import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt, faGripLines } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ReactDragListView from 'react-drag-listview'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class FormFields extends Component {

    constructor(props) {
        super(props);
        this.selectOptions = <>
            <option value="">Select</option>
            <option value="text">Text</option>
            <option value="textarea">Paragraph</option>
            <option value="select">Dropdown</option>
            <option value="number">Numeric</option>
            <option value="currency">Currency</option>
            <option value="date">Date</option>
            <option value="time">Time</option>
            <option value="checkbox">Checkbox</option>
            <option value="radio">Yes/No</option>
            <option value="multiple">Multiple</option>
            <option value="header">Header</option>
        </>;

        this.state = {
            filterForm: 0
        }
    }

    standardRow = (formField) => {
        this.props.info('FormFields.js/standardRow (formField)', formField);
        return (
            <Row className="adminRow pointer formFieldRow" onClick={() => this.props.onEdit(formField.formFieldId)}>
                <Col md={4} className="text-left">
                    <FontAwesomeIcon icon={(formField['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((formField['active']) ? 'iconActive' : 'iconInactive')} />
                    {formField['field']}
                </Col>
                <Col md={7} className="text-left">{formField['type']}</Col>
                {this.props.editFormField.formFieldId === 0 ?
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Reorder Form Fields">
                        <Col md={1} className="text-right" >
                            <span className="dragIconFormField p-2"><FontAwesomeIcon icon={faGripLines} /></span>
                        </Col>
                    </PermissionWrapper>
                    : <></>}
            </Row>
        )
    }

    editRow = (formField) => {
        this.props.log('FormFields.js/editRow (formField)', formField);
        return (
            <Row className="editRow adminRow activeTab">
                <Col md={9} className="text-left">
                    <Form inline>
                        <FormGroup className="p-1">
                            <Input
                                placeholder="Field"
                                type="text"
                                id="formField-edit-field"
                                name="field"
                                value={this.props.isFieldNull(this.props.editFormField.field)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                placeholder="Unique ID"
                                type="text"
                                id="formField-edit-uniqueId"
                                name="uniqueId"
                                value={this.props.isFieldNull(this.props.editFormField.uniqueId)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                placeholder="Type"
                                type="select"
                                id="formField-edit-type"
                                name="type"
                                value={this.props.isFieldNull(this.props.editFormField.type)}
                                onChange={e => this.props.onChange(e, 'edit')} >
                                {this.selectOptions}
                            </Input>
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                type="checkbox"
                                id={"formField-edit-required" + formField.formFieldId}
                                name="required"
                                checked={this.props.isFieldNull(this.props.editFormField.required, true)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                            <Label for={"formField-edit-required" + formField.formFieldId}>
                                Required
                            </Label>
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                placeholder="Default"
                                type="text"
                                id="formField-edit-default"
                                name="default"
                                value={this.props.isFieldNull(this.props.editFormField.default)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                placeholder="Limit"
                                type="number"
                                id="formField-edit-limit"
                                name="limit"
                                value={this.props.isFieldNull(this.props.editFormField.limit)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                type="checkbox"
                                id={"formField-edit-active" + formField.formFieldId}
                                name="active"
                                checked={this.props.isFieldNull(this.props.editFormField.active, true)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                            <Label for={"formField-edit-active" + formField.formFieldId}>
                                Active
                            </Label>
                        </FormGroup>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Form Field Rules">
                            <FormGroup className="p-1 w-100">
                                <Input
                                    type="textarea"
                                    className="w-75"
                                    rows={12}
                                    id={"formField-edit-rules" + formField.formFieldId}
                                    name="rules"
                                    value={this.props.isFieldNull(this.props.editFormField.rules, true)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                                <Label for={"formField-edit-rules" + formField.formFieldId} className="p-1">
                                    Rules
                                </Label>
                            </FormGroup>
                        </PermissionWrapper>
                    </Form>
                </Col>
                <Col md={3} className="text-right">
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Form Fields">
                        <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Form Field">
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Form Fields">
                        <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(formField.formFieldId)} edit="Delete Service Column">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton>
                    </PermissionWrapper>
                    <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
                {/* <Col md={4} className="text-right p-3">
                    Assigned Forms
                </Col>
                <Col md={8} className="text-left px-5 pt-3 maxHpanel">
                    {this.props.forms.map(form => (
                        <div key={"service-" + form.formId}><Label for={"form_" + form.formId}>
                            <Input
                                type="checkbox"
                                name="forms"
                                id={"form_" + form.formId + "_" + formField.formFieldId}
                                checked={this.props.isFieldNull(this.props.editFormField.forms.findIndex(i => i.formId === parseInt(form.formId)) > -1, true)}
                                onChange={e => this.props.onChange(e, 'edit')}
                            />
                            {form.name}
                        </Label></div>
                    )
                    )}
                </Col> */}
            </Row>
        )
    }

    addRow = () => {
        this.props.info('FormFields.js/standardRow');
        return (
            <Row className="py-4 text-left align-items-bottom ">
                <Col md={10}>
                    <Form inline>
                        <FormGroup className="p-1">
                            <Input
                                placeholder="Field"
                                type="text"
                                id="formField-add-field"
                                name="field"
                                value={this.props.isFieldNull(this.props.newFormField.field)}
                                onChange={e => this.props.onChange(e)} />
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                placeholder="Unique ID"
                                type="text"
                                id="formField-add-uniqueId"
                                name="uniqueId"
                                value={this.props.isFieldNull(this.props.newFormField.uniqueId)}
                                onChange={e => this.props.onChange(e)} />
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                placeholder="Type"
                                type="select"
                                id="formField-add-type"
                                name="type"
                                value={this.props.isFieldNull(this.props.newFormField.type)}
                                onChange={e => this.props.onChange(e)} >
                                {this.selectOptions}
                            </Input>
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                type="checkbox"
                                id={"formField-add-required"}
                                name="required"
                                checked={this.props.isFieldNull(this.props.newFormField.required, true)}
                                onChange={e => this.props.onChange(e)} />
                            <Label for={"formField-add-required"}>
                                Required
                            </Label>
                        </FormGroup>
                        <FormGroup className="p-1">
                            <Input
                                placeholder="Default"
                                type="text"
                                id="formField-add-default"
                                name="default"
                                value={this.props.isFieldNull(this.props.newFormField.default)}
                                onChange={e => this.props.onChange(e)} />
                        </FormGroup>
                        {this.props.newFormField.type === 'text' || this.props.newFormField.type === 'textarea' ? <FormGroup className="pr-2">
                            <Input
                                placeholder="Character Limit"
                                type="number"
                                id="formField-add-limit"
                                name="limit"
                                value={this.props.isFieldNull(this.props.newFormField.limit)}
                                onChange={e => this.props.onChange(e)} />
                        </FormGroup> : null}
                        <FormGroup className="p-1">
                            <Input
                                type="checkbox"
                                id={"formField-add-active"}
                                name="active"
                                checked={this.props.isFieldNull(this.props.newFormField.active, true)}
                                onChange={e => this.props.onChange(e)} />
                            <Label for={"formField-add-active"}>
                                Active
                            </Label>
                        </FormGroup>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Form Field Rules">
                            <FormGroup className="p-1 w-100">
                                <Input
                                    type="textarea"
                                    className="w-75"
                                    rows={12}
                                    id={"formField-add-rules"}
                                    name="rules"
                                    value={this.props.isFieldNull(this.props.newFormField.rules, true)}
                                    onChange={e => this.props.onChange(e)} />
                                <Label for={"formField-add-rules"} className="p-1">
                                    Rules
                                </Label>
                            </FormGroup>
                        </PermissionWrapper>
                    </Form>
                </Col>
                <Col md={2} className="text-right">
                    <Button
                        disabled={this.props.newFormField.field === ''}
                        color="primary"
                        onClick={this.props.handleAdd}
                    >Add Field</Button>
                </Col>
            </Row>
        )
    }

    render() {
        this.props.info('FormFields.js/render');
        return (
            <Container className="adminContainer" fluid>
                <Row>
                    <Col md={4} className="py-3">
                        <Input
                            type="select"
                            name="filterForm"
                            value={this.state.filterForm}
                            onChange={(e) => this.setState({ filterForm: parseInt(e.target.value) })}
                        >
                            <option value="0">All Form Fields</option>
                            {this.props.forms.map(form => (
                                <option key={form.formId} value={form.formId}>{form.name}</option>
                            ))}
                            <option value="-1">Form Not Set</option>
                        </Input>
                    </Col>
                </Row>
                <ReactDragListView {...this.props.dragPropsFormField}>
                    {this.props.formFields.filter(formField => {
                        if (parseInt(this.state.filterForm) === 0) return true;
                        if (formField.forms == null && parseInt(this.state.filterForm) === -1) return true;
                        if (formField.forms == null) return false;
                        let retBool = false;
                        formField.forms.forEach(form => {
                            if (parseInt(form.formId) === parseInt(this.state.filterForm)) retBool = true;
                        })
                        return retBool;
                    }).map(formField => (
                        <Fragment key={"formField-" + formField.formFieldId}>{this.props.editFormField.formFieldId === formField.formFieldId ? this.editRow(formField) : this.standardRow(formField)}</Fragment>
                    ))}
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Form Fields">
                        {this.addRow()}
                    </PermissionWrapper>
                </ReactDragListView>
            </Container>
        );

    }
}

export default FormFields;